import { getScreenBreakpoints, getScreenWidth } from "./screen";

window.cga2026_script_vars = window.cga2026_script_vars || {};

const initContainerSlider = ( container, items ) => {
	container.classList.add( 'slider-initiated' );

	if ( items.length <= 1 ) {
		container.classList.add( 'no-carousel' );
		return;
	}

	const swiper_options = {
		loop: true,
		speed: 1200,
		autoplay: {
			delay: 4000,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		}
	};
	
	setTimeout(() => {
		if ( typeof window.initCgaSlider !== 'undefined' ) {
			window.initCgaSlider( 
				container,
				items, 
				swiper_options
			);
		}	
	}, 500 );
};

const resetContainerSlider = ( container ) => {
	container.classList.remove( 'slider-initiated' );
	container.classList.remove( 'no-carousel' );
};

const initClassSlider = ( container ) => {
	let sliderContainer = null;
	let sliderItems = [];
	if ( container.classList.contains( 'wp-block-cgablock-cga-post-type-list' ) ) {
		sliderContainer = container.querySelector( '.cga-posts-list' );
		if ( sliderContainer !== null ) {
			sliderItems = sliderContainer.querySelectorAll( '.cga-post-list' );
		}
	} else {
		sliderContainer = container;
		sliderItems = container.querySelectorAll( ':scope > *' );
	}

	if ( sliderItems.length > 0 ) {
		initContainerSlider( sliderContainer, sliderItems );
	}
}

const initSliders = () => {
	const allSliderClassContainers = document.querySelectorAll( '.all-as-sliders' );
	if ( allSliderClassContainers.length > 0 ) {	
		allSliderClassContainers.forEach( container => {
			initClassSlider( container );
		});
	}

	if ( getScreenWidth() > getScreenBreakpoints( 'lg' ) ) {

		const desktopSliderClassContainers = document.querySelectorAll( '.desktop-as-sliders' );
		if ( desktopSliderClassContainers.length > 0 ) {	
			desktopSliderClassContainers.forEach( container => {
				initClassSlider( container );
			});
		}

	}
	
	if ( getScreenWidth() <= getScreenBreakpoints( 'lg' ) ) {

		const mobileSliderClassContainers = document.querySelectorAll( '.mobile-as-sliders' );
		if ( mobileSliderClassContainers.length > 0 ) {	
			mobileSliderClassContainers.forEach( container => {
				initClassSlider( container );
			});
		}

	}
};

const resetClassSlider = ( container ) => {
	const slider_key = container.dataset.sliderkey;
	if ( slider_key ) {
		if ( typeof window.resetCgaSlider !== 'undefined' ) {
			resetContainerSlider( container );
			window.resetCgaSlider( container, slider_key );
		}
	}
};

const resetSliders = () => {

	const allSliderClassContainers = document.querySelectorAll( '.all-as-sliders' );
	if ( allSliderClassContainers.length > 0 ) {	
		allSliderClassContainers.forEach( container => {
			resetClassSlider( container );
		});
	}

	const desktopSliderClassContainers = document.querySelectorAll( '.desktop-as-sliders' );
	if ( desktopSliderClassContainers.length > 0 ) {	
		desktopSliderClassContainers.forEach( container => {
			resetClassSlider( container );
		});
	}

	const mobileSliderClassContainers = document.querySelectorAll( '.mobile-as-sliders' );
	if ( mobileSliderClassContainers.length > 0 ) {	
		mobileSliderClassContainers.forEach( container => {
			resetClassSlider( container );
		});
	}

};

export { initSliders, resetSliders, initContainerSlider, resetContainerSlider };